import React, { Fragment } from 'react';
import './breadcrumbHeading.css';
import PropTypes from 'prop-types';

const BreadcrumbHeading = (props) => {
    return (
        <Fragment>
            <div className="view-heading">
                <h2 className="text-semibold margin-none">{props.heading}</h2>
            </div>
        </Fragment>
    );
};
export default BreadcrumbHeading;

BreadcrumbHeading.propTypes = {
    type: PropTypes.string,
    heading: PropTypes.object,
    className: PropTypes.string,
    breadcrumbs: PropTypes.array
};


// WEBPACK FOOTER //
// ./src/components/global/BreadcrumbHeading/index.js